module.exports = __webpack_public_path__ + "static/media/whether.9c773043.png";